import React from "react";
import { FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { COMPANY_DATA, CONTACT_DATA, NAVBAR_DATA } from "data";
import { handleClickScroll } from "utils";
import { Link } from "react-router-dom";

// Footer
const Footer = () => {
  return (
    <div className="max-w-[1240px] mx-auto py-16 px-4 grid lg:grid-cols-3 gap-8 text-gray-300">
      <div>
        <h1 className="w-full text-3xl font-bold text-[#00df9a]">
          {COMPANY_DATA.name}
        </h1>
        <p className="py-4">
          Copyright &copy; {new Date().getFullYear()}. All rights recieved.
        </p>
        <div className="flex gap-4 md:w-[75%] my-6">
          <FaLinkedinIn size={30} />
          <FaTwitter size={30} />
        </div>
      </div>
      <div className="lg:col-span-2 flex gap-32 mt-6">
        <div>
          <h6 className="font-medium text-gray-400">Company</h6>
          <ul>
            {NAVBAR_DATA.map((item) => (
              <Link
                className="py-2 text-sm cursor-pointer"
                to={"/"}
                key={item.id}
                onClick={() => handleClickScroll(item.scrollTo.toLowerCase())}
              >
                <li className="py-1">{item.name}</li>
              </Link>
            ))}
          </ul>
        </div>
        <div>
          <h6 className="font-medium text-gray-400">Contact</h6>
          <ul>
            <li className="py-1">{CONTACT_DATA.tel}</li>
            <li className="py-1">{CONTACT_DATA.email}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
